// extracted by mini-css-extract-plugin
module.exports = {"order":"order_order__3hHg8","ingredient":"order_ingredient__Udrfh"};